<script context="module">
    let memoryFunnelCache = null;
    let hasLoadedFunnelOnce = false;
</script>

<script>
    import { onMount } from 'svelte';
    import { 
        fetchAiFunnel, 
        updateAiFunnel, 
        resetSimulatorSession, 
        getCurrentStore, 
        safeApiFetch 
    } from '../services/api';
    import Icon from '../components/icons/Icon.svelte';

    export let onNotify = (msg, type) => {};

    let isLoading = !hasLoadedFunnelOnce && !memoryFunnelCache;
    let isSaving = false;
    let isResetting = false;

    // Aba ativa em telas menores (mobile / tablet compacto)
    let mobileViewTab = 'config'; // 'config' | 'simulator'

    // Configurações do Funil da Loja
    let welcomeMessage = '';
    let sendMenuLink = true;
    let askOrderTypeFirst = false;
    let allowPickup = true;
    let allowDelivery = true;
    let upsellEnabled = true;
    let upsellMessage = '';
    let acceptPix = true;
    let acceptCard = true;
    let acceptCash = true;
    let pixKey = '';
    let pixKeyType = 'cnpj';
    let supportMessage = '';
    let aiPersonalityPrompt = '';
    let storeName = 'MataFome';
    let storeSlug = '';

    // Simulador WhatsApp em Tempo Real
    const SIMULATOR_PHONE = '5511999990000';
    let simulatorMessages = [];
    let simulatorInput = '';
    let isAiTyping = false;
    let chatMessagesContainer;

    onMount(async () => {
        const mainEl = document.querySelector('.main-content');
        if (mainEl) mainEl.scrollTop = 0;
        if (memoryFunnelCache) { applyFunnelData(memoryFunnelCache); isLoading = false; }
        await loadFunnel();
        initSimulatorDefault();
    });

    
    function applyFunnelData(data) {
        if (!data) return;
        memoryFunnelCache = data;
        hasLoadedFunnelOnce = true;
        welcomeMessage = data.welcome_message || '';
        sendMenuLink = data.send_menu_link !== undefined ? data.send_menu_link : true;
        askOrderTypeFirst = data.ask_order_type_first !== undefined ? data.ask_order_type_first : false;
        allowPickup = data.allow_pickup !== undefined ? data.allow_pickup : true;
        allowDelivery = data.allow_delivery !== undefined ? data.allow_delivery : true;
        upsellEnabled = data.upsell_enabled !== undefined ? data.upsell_enabled : true;
        upsellMessage = data.upsell_message || '';
        acceptPix = data.accept_pix !== undefined ? data.accept_pix : true;
        acceptCard = data.accept_card !== undefined ? data.accept_card : true;
        acceptCash = data.accept_cash !== undefined ? data.accept_cash : true;
        pixKey = data.pix_key || '';
        pixKeyType = data.pix_key_type || 'cnpj';
        supportMessage = data.support_message || '';
        aiPersonalityPrompt = data.ai_personality_prompt || '';
        if (data.store_name) storeName = data.store_name;
    }

    async function loadFunnel() {
        isLoading = true;
        try {
            const store = getCurrentStore();
            if (store) {
                storeName = store.name || 'MataFome';
                storeSlug = store.slug || '';
            }

            const data = await fetchAiFunnel(store?.id);
            if (data) {
                applyFunnelData(data);
            }
        } catch (err) {
            console.error('Erro ao buscar funil:', err);
            if (onNotify) onNotify('Não foi possível carregar as configurações do funil.', 'warning');
        } finally {
            isLoading = false;
        }
    }

    async function handleSaveFunnel() {
        isSaving = true;
        try {
            const store = getCurrentStore();
            const payload = {
                welcome_message: welcomeMessage,
                send_menu_link: sendMenuLink,
                ask_order_type_first: askOrderTypeFirst,
                allow_pickup: allowPickup,
                allow_delivery: allowDelivery,
                upsell_enabled: upsellEnabled,
                upsell_message: upsellMessage,
                accept_pix: acceptPix,
                accept_card: acceptCard,
                accept_cash: acceptCash,
                pix_key: pixKey,
                pix_key_type: pixKeyType,
                support_message: supportMessage,
                ai_personality_prompt: aiPersonalityPrompt
            };

            await updateAiFunnel(payload, store?.id);
            if (onNotify) onNotify('Funil do Agente salvo com sucesso!', 'success');
        } catch (err) {
            console.error('Erro ao salvar funil:', err);
            if (onNotify) onNotify('Erro ao salvar as alterações do funil.', 'error');
        } finally {
            isSaving = false;
        }
    }

    function insertVariable(variableName) {
        welcomeMessage += variableName;
    }

    function initSimulatorDefault() {
        simulatorMessages = [
            {
                fromMe: false,
                text: 'Olá, boa noite!',
                time: '19:30'
            },
            {
                fromMe: true,
                text: welcomeMessage || `Olá! Seja muito bem-vindo ao ${storeName}! 🍔🔥\n\nSou o atendente virtual inteligente e estou pronto para anotar seu pedido!`,
                time: '19:30'
            }
        ];
    }

    async function handleSendSimulatorMessage(customText = null) {
        const text = (customText || simulatorInput).trim();
        if (!text) return;

        simulatorInput = '';
        const nowTime = new Date().toLocaleTimeString().slice(0, 5);

        simulatorMessages = [
            ...simulatorMessages,
            { fromMe: false, text, time: nowTime }
        ];
        scrollToBottom();

        isAiTyping = true;
        try {
            const store = getCurrentStore();
            const res = await safeApiFetch('/api/ai/chat', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    storeId: store?.id || '',
                    storeSlug: storeSlug || '',
                    customerPhone: SIMULATOR_PHONE,
                    customerName: 'Cliente Teste',
                    message: text
                })
            });

            const data = await res.json();
            isAiTyping = false;

            if (data && data.reply) {
                simulatorMessages = [
                    ...simulatorMessages,
                    {
                        fromMe: true,
                        text: data.reply,
                        time: new Date().toLocaleTimeString().slice(0, 5),
                        intent: data.intent
                    }
                ];
                scrollToBottom();
            }
        } catch (err) {
            isAiTyping = false;
            simulatorMessages = [
                ...simulatorMessages,
                {
                    fromMe: true,
                    text: 'Ops! Ocorreu uma instabilidade ao conectar ao robô de testes.',
                    time: new Date().toLocaleTimeString().slice(0, 5)
                }
            ];
            scrollToBottom();
        }
    }

    async function handleResetSimulator() {
        isResetting = true;
        try {
            const store = getCurrentStore();
            await resetSimulatorSession(SIMULATOR_PHONE, store?.id);
            simulatorMessages = [];
            initSimulatorDefault();
            if (onNotify) onNotify('Sessão de teste reiniciada!', 'info');
        } catch (e) {
            console.warn(e);
        } finally {
            isResetting = false;
        }
    }

    function scrollToBottom() {
        setTimeout(() => {
            if (chatMessagesContainer) {
                chatMessagesContainer.scrollTop = chatMessagesContainer.scrollHeight;
            }
        }, 60);
    }
</script>

<div class="funnel-container" id="funnel-view">
    <!-- Header Principal -->
    <header class="funnel-header">
        <div class="header-left">
            <div class="header-badge">
                <span class="badge-dot"></span>
                <span>FLUXO CONVERSACIONAL DE IA</span>
            </div>
            <h1 class="header-title">Funil do Agente</h1>
            <p class="header-subtitle">
                Personalize cada etapa da conversa automática no WhatsApp, ative gatilhos de vendas e teste as respostas do robô ao vivo.
            </p>
        </div>

        <div class="header-actions">
            <button 
                type="button" 
                class="btn-reset-simulator" 
                on:click={handleResetSimulator} 
                disabled={isResetting}
                title="Reinicia o carrinho e o fluxo do chat de teste"
                id="btn-reset-chat"
            >
                <Icon name="refresh" size={15} />
                <span>{isResetting ? 'Limpando...' : 'Limpar Teste'}</span>
            </button>

            <button 
                type="button" 
                class="btn-save-funnel" 
                on:click={handleSaveFunnel} 
                disabled={isSaving || isLoading}
                id="btn-save-funnel"
            >
                {#if isSaving}
                    <span class="spinner-small"></span>
                    <span>Salvando...</span>
                {:else}
                    <Icon name="save" size={16} />
                    <span>Salvar Funil</span>
                {/if}
            </button>
        </div>
    </header>

    <!-- Barra de Navegação Mobile (Alternância Configuração / Simulador) -->
    <div class="mobile-funnel-nav">
        <button
            type="button"
            class="mobile-tab-btn {mobileViewTab === 'config' ? 'active' : ''}"
            on:click={() => mobileViewTab = 'config'}
        >
            <Icon name="settings" size={15} />
            <span>Configurar Etapas</span>
        </button>
        <button
            type="button"
            class="mobile-tab-btn {mobileViewTab === 'simulator' ? 'active' : ''}"
            on:click={() => mobileViewTab = 'simulator'}
        >
            <Icon name="bot" size={15} />
            <span>Simulador de Celular</span>
        </button>
    </div>

    {#if isLoading}
        <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>Carregando configurações do funil do agente...</p>
        </div>
    {:else}
        <div class="funnel-layout">
            <!-- COLUNA ESQUERDA: CONFIGURADOR DE ETAPAS -->
            <div class="funnel-builder {mobileViewTab === 'config' ? 'mobile-visible' : 'mobile-hidden'}">
                <!-- ETAPA 1: BOAS-VINDAS E CARDÁPIO -->
                <section class="funnel-card" id="card-welcome">
                    <div class="card-header">
                        <div class="card-step-badge">1</div>
                        <div class="card-title-group">
                            <h2>Boas-Vindas & Abertura</h2>
                            <p>Primeiro contato do robô quando o cliente manda qualquer saudação inicial no WhatsApp.</p>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="form-group">
                            <label for="welcome-msg">Mensagem de Boas-Vindas:</label>
                            <div class="variable-chips">
                                <span class="chip-label">Variáveis dinâmicas:</span>
                                <button type="button" class="chip-btn" on:click={() => insertVariable('{nome_cliente}')} title="Insere o nome do cliente detectado">
                                    + &#123;nome_cliente&#125;
                                </button>
                                <button type="button" class="chip-btn" on:click={() => insertVariable('{nome_loja}')} title="Insere o nome da loja">
                                    + &#123;nome_loja&#125;
                                </button>
                            </div>
                            <textarea 
                                id="welcome-msg"
                                bind:value={welcomeMessage} 
                                rows="4" 
                                placeholder="Olá! Seja muito bem-vindo ao &#123;nome_loja&#125;! Como posso ajudar?"
                            ></textarea>
                            <span class="field-hint">Esta mensagem é enviada automaticamente assim que o cliente inicia a conversa.</span>
                        </div>

                        <div class="toggles-grid">
                            <label class="switch-card">
                                <div class="switch-content">
                                    <span class="switch-title">Enviar Cardápio Digital</span>
                                    <span class="switch-desc">Anexa o link oficial do cardápio com fotos já na primeira saudação.</span>
                                </div>
                                <input type="checkbox" bind:checked={sendMenuLink} />
                                <span class="slider"></span>
                            </label>

                            <label class="switch-card">
                                <div class="switch-content">
                                    <span class="switch-title">Perguntar Tipo de Pedido Primeiro</span>
                                    <span class="switch-desc">Pergunta se é Retirada ou Entrega antes de aceitar os itens do carrinho.</span>
                                </div>
                                <input type="checkbox" bind:checked={askOrderTypeFirst} />
                                <span class="slider"></span>
                            </label>
                        </div>
                    </div>
                </section>

                <!-- ETAPA 2: LOGÍSTICA & MODALIDADES -->
                <section class="funnel-card" id="card-logistics">
                    <div class="card-header">
                        <div class="card-step-badge">2</div>
                        <div class="card-title-group">
                            <h2>Modalidades de Atendimento</h2>
                            <p>Defina quais formas de entrega o assistente virtual pode oferecer aos clientes.</p>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="toggles-grid">
                            <label class="switch-card">
                                <div class="switch-content">
                                    <span class="switch-title">Permitir Entrega (Delivery)</span>
                                    <span class="switch-desc">O robô coleta o endereço do cliente e adiciona taxa de entrega configurada.</span>
                                </div>
                                <input type="checkbox" bind:checked={allowDelivery} />
                                <span class="slider"></span>
                            </label>

                            <label class="switch-card">
                                <div class="switch-content">
                                    <span class="switch-title">Permitir Retirada no Balcão</span>
                                    <span class="switch-desc">Permite ao cliente optar por buscar o pedido diretamente no restaurante.</span>
                                </div>
                                <input type="checkbox" bind:checked={allowPickup} />
                                <span class="slider"></span>
                            </label>
                        </div>
                    </div>
                </section>

                <!-- ETAPA 3: UPSELL AUTOMÁTICO (AUMENTO DE TICKET) -->
                <section class="funnel-card highlight-card" id="card-upsell">
                    <div class="card-header">
                        <div class="card-step-badge gradient">3</div>
                        <div class="card-title-group">
                            <div class="badge-tag">AUMENTO DE TICKET MÉDIO</div>
                            <h2>Oferta Turbinada (Upsell Inteligente)</h2>
                            <p>Ofereça bebidas, sobremesas ou combos antes do fechamento para elevar o faturamento da loja.</p>
                        </div>
                    </div>

                    <div class="card-body">
                        <label class="switch-card highlight">
                            <div class="switch-content">
                                <span class="switch-title">Ativar Oferta Complementar no Carrinho</span>
                                <span class="switch-desc">Quando o cliente adiciona itens ao carrinho, o bot sugere um complemento irresistível.</span>
                            </div>
                            <input type="checkbox" bind:checked={upsellEnabled} />
                            <span class="slider"></span>
                        </label>

                        {#if upsellEnabled}
                            <div class="form-group" style="margin-top: 14px;">
                                <label for="upsell-msg">Frase Persuasiva de Upsell:</label>
                                <textarea 
                                    id="upsell-msg"
                                    bind:value={upsellMessage} 
                                    rows="2" 
                                    placeholder="🥤 Que tal uma bebida bem gelada ou uma sobremesa deliciosa para acompanhar seu pedido?"
                                ></textarea>
                                <span class="field-hint">Esta frase será apresentada aos clientes no fechamento do carrinho.</span>
                            </div>
                        {/if}
                    </div>
                </section>

                <!-- ETAPA 4: PAGAMENTOS & PIX -->
                <section class="funnel-card" id="card-payments">
                    <div class="card-header">
                        <div class="card-step-badge">4</div>
                        <div class="card-title-group">
                            <h2>Formas de Pagamento no WhatsApp</h2>
                            <p>Escolha os métodos que o robô pode apresentar na etapa de fechamento de conta.</p>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="payment-methods-grid">
                            <label class="payment-check-card {acceptPix ? 'selected' : ''}">
                                <input type="checkbox" bind:checked={acceptPix} />
                                <div class="check-icon"><Icon name="zap" size={20} /></div>
                                <div class="check-text">
                                    <strong>PIX Automático</strong>
                                    <span>Gera código copia e cola</span>
                                </div>
                            </label>

                            <label class="payment-check-card {acceptCard ? 'selected' : ''}">
                                <input type="checkbox" bind:checked={acceptCard} />
                                <div class="check-icon"><Icon name="credit-card" size={20} /></div>
                                <div class="check-text">
                                    <strong>Cartão</strong>
                                    <span>Maquininha na entrega</span>
                                </div>
                            </label>

                            <label class="payment-check-card {acceptCash ? 'selected' : ''}">
                                <input type="checkbox" bind:checked={acceptCash} />
                                <div class="check-icon"><Icon name="dollar-sign" size={20} /></div>
                                <div class="check-text">
                                    <strong>Dinheiro</strong>
                                    <span>Calcula troco necessário</span>
                                </div>
                            </label>
                        </div>

                        {#if acceptPix}
                            <div class="pix-config-box">
                                <div class="form-group-inline">
                                    <div class="form-group" style="flex: 1;">
                                        <label for="pix-type">Tipo de Chave PIX:</label>
                                        <select id="pix-type" bind:value={pixKeyType}>
                                            <option value="cnpj">CNPJ</option>
                                            <option value="cpf">CPF</option>
                                            <option value="phone">Celular</option>
                                            <option value="email">E-mail</option>
                                            <option value="random">Chave Aleatória (EVP)</option>
                                        </select>
                                    </div>
                                    <div class="form-group" style="flex: 2;">
                                        <label for="pix-key-val">Chave PIX do Estabelecimento:</label>
                                        <input 
                                            id="pix-key-val"
                                            type="text" 
                                            bind:value={pixKey} 
                                            placeholder="Ex: 12.345.678/0001-90 ou financeiro@restaurante.com" 
                                        />
                                    </div>
                                </div>
                                <span class="field-hint">Esta chave é utilizada pelo robô para instruir pagamentos via PIX.</span>
                            </div>
                        {/if}
                    </div>
                </section>

                <!-- ETAPA 5: ATENDIMENTO HUMANO & TRANSBORDO -->
                <section class="funnel-card" id="card-support">
                    <div class="card-header">
                        <div class="card-step-badge">5</div>
                        <div class="card-title-group">
                            <h2>Transbordo para Atendente Humano</h2>
                            <p>Resposta enviada quando o cliente solicita falar com uma pessoa ou suporte da equipe.</p>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="form-group">
                            <label for="support-msg">Mensagem de Transferência para Atendente:</label>
                            <textarea 
                                id="support-msg"
                                bind:value={supportMessage} 
                                rows="3" 
                                placeholder="🙋‍♂️ Entendido! Já chamei um atendente da nossa equipe. Em instantes alguém do &#123;nome_loja&#125; irá te responder por aqui!"
                            ></textarea>
                            <span class="field-hint">O robô pausa o atendimento para este cliente e emite um alerta na Central de WhatsApp.</span>
                        </div>
                    </div>
                </section>

                <!-- ETAPA 6: DIRETRIZES & PERSONALIDADE DA IA -->
                <section class="funnel-card" id="card-personality">
                    <div class="card-header">
                        <div class="card-step-badge">6</div>
                        <div class="card-title-group">
                            <h2>Personalidade & Instruções Especiais</h2>
                            <p>Dite o tom de voz e regras particulares que a inteligência artificial deve seguir.</p>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="form-group">
                            <label for="personality-prompt">Diretrizes Livres para o Agente:</label>
                            <textarea 
                                id="personality-prompt"
                                bind:value={aiPersonalityPrompt} 
                                rows="3" 
                                placeholder="Ex: Seja bem-humorado, use termos amigáveis como 'amigo' ou 'família', sempre sugira o combo especial e seja direto ao confirmar os sabores de pizza."
                            ></textarea>
                            <span class="field-hint">Estas orientações são injetadas diretamente nas regras de raciocínio da IA durante o atendimento.</span>
                        </div>
                    </div>
                </section>
            </div>

            <!-- COLUNA DIREITA: SIMULADOR WHATSAPP EM TEMPO REAL -->
            <div class="simulator-column {mobileViewTab === 'simulator' ? 'mobile-visible' : 'mobile-hidden'}">
                <div class="simulator-wrapper">
                    <div class="simulator-header-bar">
                        <span class="live-badge">AO VIVO</span>
                        <h3>Simulador de Atendimento</h3>
                        <p>Experimente o funil como se fosse um cliente real no WhatsApp.</p>
                    </div>

                    <div class="phone-frame">
                        <!-- Topo do Telefone (Status Bar) -->
                        <div class="phone-top-bar">
                            <div class="phone-time">19:30</div>
                            <div class="phone-camera-notch"></div>
                            <div class="phone-icons">
                                <Icon name="wifi" size={12} />
                                <Icon name="battery" size={12} />
                            </div>
                        </div>

                        <!-- Cabeçalho do Chat WhatsApp -->
                        <div class="whatsapp-chat-header">
                            <div class="bot-avatar">
                                <Icon name="bot" size={18} color="#0F172A" />
                            </div>
                            <div class="bot-info">
                                <h4>{storeName}</h4>
                                <span class="status-online">online agora</span>
                            </div>
                            <div class="chat-actions">
                                <button type="button" class="btn-clear-chat" on:click={handleResetSimulator} title="Limpar conversa e reiniciar sessão de teste" aria-label="Limpar conversa de teste">
                                    <Icon name="trash" size={15} />
                                </button>
                            </div>
                        </div>

                        <!-- Área de Mensagens -->
                        <div class="whatsapp-messages" bind:this={chatMessagesContainer}>
                            <div class="chat-date-chip">HOJE</div>

                            {#each simulatorMessages as msg}
                                <div class="chat-bubble {msg.fromMe ? 'bot-bubble' : 'user-bubble'}">
                                    <div class="bubble-text">{msg.text}</div>
                                    <div class="bubble-time">{msg.time}</div>
                                </div>
                            {/each}

                            {#if isAiTyping}
                                <div class="chat-bubble bot-bubble typing-bubble">
                                    <div class="typing-dots">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            {/if}
                        </div>

                        <!-- Atalhos Rápidos de Teste -->
                        <div class="quick-chips">
                            <button type="button" on:click={() => handleSendSimulatorMessage("Qual o cardápio de hoje?")}>
                                <Icon name="book-open" size={12} /> Cardápio
                            </button>
                            <button type="button" on:click={() => handleSendSimulatorMessage("Quero 1 Smash Duplo")}>
                                <Icon name="shopping-bag" size={12} /> Quero 1 Smash
                            </button>
                            <button type="button" on:click={() => handleSendSimulatorMessage("1")}>
                                <Icon name="arrow-right" size={12} /> 1 (Avançar)
                            </button>
                            <button type="button" on:click={() => handleSendSimulatorMessage("Rua das Palmeiras 45, Centro")}>
                                <Icon name="map-pin" size={12} /> Endereço
                            </button>
                            <button type="button" on:click={() => handleSendSimulatorMessage("Vou pagar no PIX")}>
                                <Icon name="zap" size={12} /> Pagar PIX
                            </button>
                            <button type="button" on:click={() => handleSendSimulatorMessage("Quero falar com atendente")}>
                                <Icon name="user" size={12} /> Atendente
                            </button>
                        </div>

                        <!-- Input de Mensagem do Simulador -->
                        <form class="whatsapp-input-bar" on:submit|preventDefault={() => handleSendSimulatorMessage()}>
                            <input 
                                type="text" 
                                bind:value={simulatorInput} 
                                placeholder="Digite uma mensagem para testar..."
                                id="simulator-input"
                                aria-label="Mensagem de teste para o robô"
                            />
                            <button type="submit" class="btn-send-sim" disabled={isAiTyping || !simulatorInput.trim()} aria-label="Enviar mensagem de teste">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                                    <line x1="22" y1="2" x2="11" y2="13"></line>
                                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                                </svg>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    {/if}
</div>

<style>
    /* =========================================================================
       DESIGN SYSTEM & LAYOUT: FUNIL DO AGENTE
       ========================================================================= */
    .funnel-container {
        flex: 1;
        min-height: 0;
        height: 100%;
        max-height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 24px 32px 80px;
        max-width: 1560px;
        margin: 0 auto;
        width: 100%;
        color: var(--color-neutral-900, #0F172A);
        font-family: inherit;
    }

    .funnel-container::-webkit-scrollbar {
        width: 6px;
    }

    .funnel-container::-webkit-scrollbar-track {
        background: transparent;
    }

    .funnel-container::-webkit-scrollbar-thumb {
        background: var(--color-neutral-300, #CBD5E1);
        border-radius: 4px;
    }

    .funnel-container::-webkit-scrollbar-thumb:hover {
        background: var(--color-neutral-400, #94A3B8);
    }

    /* HEADER */
    .funnel-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding-bottom: 20px;
        border-bottom: 1px solid var(--color-neutral-200, #E2E8F0);
        gap: 20px;
        flex-wrap: wrap;
    }

    .header-left {
        max-width: 760px;
    }

    .header-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 4px 10px;
        background: rgba(255, 106, 0, 0.08);
        border: 1px solid rgba(255, 106, 0, 0.2);
        border-radius: 999px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.05em;
        color: var(--color-brand-600, #EA580C);
        margin-bottom: 8px;
    }

    .badge-dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: var(--color-brand-500, #FF6A00);
        box-shadow: 0 0 8px rgba(255, 106, 0, 0.5);
    }

    .header-title {
        font-size: 26px;
        font-weight: 800;
        color: var(--color-neutral-900, #0F172A);
        margin: 0 0 6px;
        letter-spacing: -0.02em;
    }

    .header-subtitle {
        font-size: 14px;
        color: var(--color-neutral-500, #64748B);
        margin: 0;
        line-height: 1.5;
    }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;
    }

    .btn-reset-simulator {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 16px;
        min-height: 44px;
        background: var(--color-neutral-0, #FFFFFF);
        border: 1px solid var(--color-neutral-300, #CBD5E1);
        border-radius: var(--radius-md, 10px);
        color: var(--color-neutral-700, #475569);
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .btn-reset-simulator:hover:not(:disabled) {
        background: var(--color-neutral-50, #F8FAFC);
        border-color: var(--color-neutral-400, #94A3B8);
        color: var(--color-neutral-900, #0F172A);
    }

    .btn-reset-simulator:focus-visible {
        outline: none;
        border-color: var(--color-brand-500, #FF6A00);
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.2);
    }

    .btn-reset-simulator:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .btn-save-funnel {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 11px 22px;
        min-height: 44px;
        background: linear-gradient(135deg, #FF6A00 0%, #EA580C 100%);
        border: none;
        border-radius: var(--radius-md, 10px);
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        box-shadow: 0 4px 14px rgba(255, 106, 0, 0.35);
        transition: all 0.2s ease;
    }

    .btn-save-funnel:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 6px 18px rgba(255, 106, 0, 0.45);
        background: linear-gradient(135deg, #FF781F 0%, #F97316 100%);
    }

    .btn-save-funnel:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.4);
    }

    .btn-save-funnel:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }

    /* BARRA DE NAVEGAÇÃO MOBILE (TABS) */
    .mobile-funnel-nav {
        display: none;
        gap: 8px;
        background: var(--color-neutral-100, #F1F5F9);
        padding: 4px;
        border-radius: var(--radius-lg, 12px);
        border: 1px solid var(--color-neutral-200, #E2E8F0);
    }

    .mobile-tab-btn {
        flex: 1;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 14px;
        min-height: 42px;
        border: none;
        border-radius: var(--radius-md, 8px);
        background: transparent;
        color: var(--color-neutral-600, #64748B);
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .mobile-tab-btn.active {
        background: var(--color-neutral-0, #FFFFFF);
        color: var(--color-neutral-900, #0F172A);
        font-weight: 700;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }

    /* GRID PRINCIPAL */
    .funnel-layout {
        display: grid;
        grid-template-columns: 1fr 420px;
        gap: 32px;
        align-items: start;
    }

    /* BUILDER (COLUNA ESQUERDA) */
    .funnel-builder {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .funnel-card {
        background: var(--color-neutral-0, #FFFFFF);
        border: 1px solid var(--color-neutral-200, #E2E8F0);
        border-radius: var(--radius-xl, 16px);
        padding: 22px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .funnel-card:hover {
        border-color: var(--color-neutral-300, #CBD5E1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    }

    .funnel-card.highlight-card {
        border-color: #FED7AA;
        background: linear-gradient(180deg, #FFFDFB 0%, #FFFFFF 100%);
    }

    .card-header {
        display: flex;
        align-items: flex-start;
        gap: 14px;
        margin-bottom: 18px;
    }

    .card-step-badge {
        width: 32px;
        height: 32px;
        border-radius: 10px;
        background: var(--color-neutral-100, #F1F5F9);
        color: var(--color-neutral-700, #334155);
        font-size: 14px;
        font-weight: 800;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        border: 1px solid var(--color-neutral-200, #E2E8F0);
    }

    .card-step-badge.gradient {
        background: linear-gradient(135deg, #FF6A00 0%, #EA580C 100%);
        color: #FFFFFF;
        border: none;
        box-shadow: 0 2px 8px rgba(255, 106, 0, 0.3);
    }

    .card-title-group {
        flex: 1;
    }

    .card-title-group h2 {
        font-size: 16px;
        font-weight: 700;
        margin: 0 0 4px;
        color: var(--color-neutral-900, #0F172A);
        line-height: 1.3;
    }

    .card-title-group p {
        font-size: 13px;
        color: var(--color-neutral-500, #64748B);
        margin: 0;
        line-height: 1.45;
    }

    .badge-tag {
        display: inline-block;
        padding: 2px 7px;
        background: #FFEDD5;
        color: #C2410C;
        border-radius: 4px;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.05em;
        margin-bottom: 4px;
    }

    /* FORMULÁRIOS & CAMPOS */
    .form-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .form-group label {
        font-size: 13px;
        font-weight: 600;
        color: var(--color-neutral-700, #334155);
    }

    .form-group textarea,
    .form-group input,
    .form-group select {
        width: 100%;
        padding: 10px 14px;
        background: var(--color-neutral-50, #F8FAFC);
        border: 1px solid var(--color-neutral-300, #CBD5E1);
        border-radius: var(--radius-md, 10px);
        font-size: 13px;
        color: var(--color-neutral-900, #0F172A);
        font-family: inherit;
        transition: all 0.2s ease;
        box-sizing: border-box;
    }

    .form-group textarea:focus,
    .form-group input:focus,
    .form-group select:focus {
        outline: none;
        background: #FFFFFF;
        border-color: var(--color-brand-500, #FF6A00);
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.15);
    }

    .field-hint {
        font-size: 11px;
        color: var(--color-neutral-500, #64748B);
        margin-top: 4px;
        line-height: 1.4;
    }

    .variable-chips {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 4px;
        flex-wrap: wrap;
    }

    .chip-label {
        font-size: 11px;
        font-weight: 500;
        color: var(--color-neutral-500, #64748B);
    }

    .chip-btn {
        background: #EFF6FF;
        border: 1px solid #BFDBFE;
        color: #1D4ED8;
        border-radius: 6px;
        padding: 4px 10px;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.15s ease, transform 0.1s ease;
    }

    .chip-btn:hover {
        background: #DBEAFE;
        transform: translateY(-1px);
    }

    .chip-btn:focus-visible {
        outline: none;
        box-shadow: 0 0 0 2px rgba(29, 78, 216, 0.3);
    }

    /* TOGGLES / SWITCHES */
    .toggles-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 14px;
        margin-top: 14px;
    }

    .switch-card {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 16px;
        background: var(--color-neutral-50, #F8FAFC);
        border: 1px solid var(--color-neutral-200, #E2E8F0);
        border-radius: var(--radius-lg, 12px);
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .switch-card:hover {
        border-color: var(--color-neutral-300, #CBD5E1);
        background: var(--color-neutral-100, #F1F5F9);
    }

    .switch-card:focus-within {
        border-color: var(--color-brand-500, #FF6A00);
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.15);
    }

    .switch-card.highlight {
        background: #FFF7ED;
        border-color: #FFEDD5;
    }

    .switch-card.highlight:hover {
        border-color: #FED7AA;
    }

    .switch-content {
        display: flex;
        flex-direction: column;
        gap: 3px;
        flex: 1;
    }

    .switch-title {
        font-size: 13px;
        font-weight: 700;
        color: var(--color-neutral-800, #1E293B);
    }

    .switch-desc {
        font-size: 11px;
        color: var(--color-neutral-500, #64748B);
        line-height: 1.35;
    }

    .switch-card input {
        position: absolute;
        opacity: 0;
        pointer-events: none;
    }

    .slider {
        width: 38px;
        height: 22px;
        background: var(--color-neutral-300, #CBD5E1);
        border-radius: 999px;
        position: relative;
        flex-shrink: 0;
        transition: background 0.25s ease;
    }

    .slider::after {
        content: '';
        position: absolute;
        width: 18px;
        height: 18px;
        background: #FFFFFF;
        border-radius: 50%;
        top: 2px;
        left: 2px;
        transition: transform 0.25s ease;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    }

    .switch-card input:checked + .slider {
        background: var(--color-brand-500, #FF6A00);
    }

    .switch-card input:checked + .slider::after {
        transform: translateX(16px);
    }

    /* PAGAMENTOS */
    .payment-methods-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
    }

    .payment-check-card {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding: 14px;
        background: var(--color-neutral-50, #F8FAFC);
        border: 2px solid var(--color-neutral-200, #E2E8F0);
        border-radius: var(--radius-lg, 12px);
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .payment-check-card:hover {
        border-color: var(--color-neutral-300, #CBD5E1);
        background: var(--color-neutral-100, #F1F5F9);
    }

    .payment-check-card:focus-within {
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.2);
    }

    .payment-check-card input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
        margin: 0;
    }

    .payment-check-card.selected {
        border-color: var(--color-brand-500, #FF6A00);
        background: #FFF7ED;
    }

    .check-icon {
        color: var(--color-brand-600, #EA580C);
        display: flex;
        align-items: center;
    }

    .check-text strong {
        display: block;
        font-size: 13px;
        color: var(--color-neutral-900, #0F172A);
        font-weight: 700;
    }

    .check-text span {
        font-size: 11px;
        color: var(--color-neutral-500, #64748B);
    }

    .pix-config-box {
        margin-top: 14px;
        padding: 16px;
        background: var(--color-neutral-50, #F8FAFC);
        border: 1px solid var(--color-neutral-200, #E2E8F0);
        border-radius: var(--radius-lg, 12px);
    }

    .form-group-inline {
        display: flex;
        gap: 12px;
    }

    /* =========================================================================
       COLUNA DO SIMULADOR (LIVE PREVIEW)
       ========================================================================= */
    .simulator-column {
        position: sticky;
        top: 24px;
    }

    .simulator-wrapper {
        display: flex;
        flex-direction: column;
        gap: 14px;
    }

    .simulator-header-bar {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .live-badge {
        align-self: flex-start;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.08em;
        background: #DCFCE7;
        color: #166534;
        padding: 3px 8px;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        gap: 4px;
    }

    .live-badge::before {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #22C55E;
        box-shadow: 0 0 6px #22C55E;
    }

    .simulator-header-bar h3 {
        font-size: 17px;
        font-weight: 800;
        margin: 0;
        color: var(--color-neutral-900, #0F172A);
    }

    .simulator-header-bar p {
        font-size: 12px;
        color: var(--color-neutral-500, #64748B);
        margin: 0;
    }

    /* FRAME DO SMARTPHONE */
    .phone-frame {
        width: 100%;
        height: 620px;
        max-height: calc(100vh - 190px);
        min-height: 500px;
        background: #ECE5DD;
        border: 10px solid #1E293B;
        border-radius: 36px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 0 0 2px #475569;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: relative;
    }

    .phone-top-bar {
        background: #075E54;
        color: #FFFFFF;
        padding: 6px 18px 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 11px;
        font-weight: 600;
    }

    .phone-camera-notch {
        width: 60px;
        height: 6px;
        background: #043832;
        border-radius: 999px;
    }

    .phone-icons {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .whatsapp-chat-header {
        background: #075E54;
        color: #FFFFFF;
        padding: 10px 14px;
        display: flex;
        align-items: center;
        gap: 10px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    }

    .bot-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        flex-shrink: 0;
    }

    .bot-info {
        flex: 1;
        overflow: hidden;
    }

    .bot-info h4 {
        font-size: 14px;
        font-weight: 700;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #FFFFFF;
    }

    .status-online {
        font-size: 11px;
        color: #A7F3D0;
    }

    .btn-clear-chat {
        background: transparent;
        border: none;
        cursor: pointer;
        color: #E2E8F0;
        opacity: 0.8;
        padding: 6px;
        border-radius: 6px;
        transition: opacity 0.2s ease, background 0.2s ease;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .btn-clear-chat:hover {
        opacity: 1;
        background: rgba(255, 255, 255, 0.15);
    }

    .btn-clear-chat:focus-visible {
        outline: none;
        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.4);
    }

    /* MENSAGENS NO CHAT */
    .whatsapp-messages {
        flex: 1;
        padding: 14px 12px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 10px;
        background-color: #ECE5DD;
        background-image: radial-gradient(#D5CEB8 1px, transparent 1px);
        background-size: 16px 16px;
    }

    .chat-date-chip {
        align-self: center;
        background: #E1DACB;
        color: #555D64;
        font-size: 10px;
        font-weight: 700;
        padding: 3px 10px;
        border-radius: 6px;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08);
        margin-bottom: 6px;
    }

    .chat-bubble {
        max-width: 82%;
        padding: 8px 10px 6px;
        border-radius: 10px;
        font-size: 12.5px;
        line-height: 1.4;
        position: relative;
        box-shadow: 0 1px 1.5px rgba(0, 0, 0, 0.15);
        word-break: break-word;
        white-space: pre-wrap;
    }

    .user-bubble {
        align-self: flex-end;
        background: #E7FFDB;
        color: #111B21;
        border-top-right-radius: 2px;
    }

    .bot-bubble {
        align-self: flex-start;
        background: #FFFFFF;
        color: #111B21;
        border-top-left-radius: 2px;
    }

    .bubble-time {
        font-size: 9.5px;
        color: #667781;
        text-align: right;
        margin-top: 3px;
    }

    /* DIGITANDO ANIMADO */
    .typing-bubble {
        padding: 10px 14px;
    }

    .typing-dots {
        display: flex;
        gap: 4px;
        align-items: center;
    }

    .typing-dots span {
        width: 6px;
        height: 6px;
        background: #8696A0;
        border-radius: 50%;
        animation: typingDot 1.4s infinite ease-in-out;
    }

    .typing-dots span:nth-child(1) { animation-delay: 0s; }
    .typing-dots span:nth-child(2) { animation-delay: 0.2s; }
    .typing-dots span:nth-child(3) { animation-delay: 0.4s; }

    @keyframes typingDot {
        0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
        30% { transform: translateY(-4px); opacity: 1; }
    }

    /* CHIPS DE TESTE RÁPIDO */
    .quick-chips {
        display: flex;
        gap: 6px;
        padding: 8px 10px;
        background: #F0F2F5;
        overflow-x: auto;
        border-top: 1px solid #E1E9EE;
        scrollbar-width: none;
    }

    .quick-chips::-webkit-scrollbar {
        display: none;
    }

    .quick-chips button {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 999px;
        padding: 4px 10px;
        font-size: 11px;
        font-weight: 600;
        color: #334155;
        cursor: pointer;
        white-space: nowrap;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        transition: all 0.15s ease;
    }

    .quick-chips button:hover {
        background: var(--color-brand-500, #FF6A00);
        color: #FFFFFF;
        border-color: var(--color-brand-500, #FF6A00);
    }

    .quick-chips button:focus-visible {
        outline: none;
        box-shadow: 0 0 0 2px rgba(255, 106, 0, 0.3);
    }

    /* BARRA DE DIGITAÇÃO DO WHATSAPP */
    .whatsapp-input-bar {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 10px;
        background: #F0F2F5;
        border-top: 1px solid #E1E9EE;
    }

    .whatsapp-input-bar input {
        flex: 1;
        padding: 9px 14px;
        border: none;
        border-radius: 20px;
        background: #FFFFFF;
        font-size: 12.5px;
        color: #111B21;
        font-family: inherit;
        outline: none;
    }

    .whatsapp-input-bar input:focus {
        box-shadow: 0 0 0 2px rgba(0, 168, 132, 0.3);
    }

    .btn-send-sim {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: #00A884;
        border: none;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background 0.2s ease;
        flex-shrink: 0;
    }

    .btn-send-sim:hover:not(:disabled) {
        background: #008f6f;
    }

    .btn-send-sim:focus-visible {
        outline: none;
        box-shadow: 0 0 0 2px rgba(0, 168, 132, 0.4);
    }

    .btn-send-sim:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    /* ESTADOS DE CARREGAMENTO */
    .loading-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 80px 20px;
        gap: 16px;
        color: var(--color-neutral-500, #64748B);
        font-size: 14px;
    }

    .loading-spinner {
        width: 36px;
        height: 36px;
        border: 3px solid var(--color-neutral-200, #E2E8F0);
        border-top-color: var(--color-brand-500, #FF6A00);
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }

    .spinner-small {
        width: 14px;
        height: 14px;
        border: 2px solid rgba(255, 255, 255, 0.4);
        border-top-color: #FFFFFF;
        border-radius: 50%;
        animation: spin 0.6s linear infinite;
    }

    @keyframes spin {
        to { transform: rotate(360deg); }
    }

    /* RESPONSIVIDADE */
    @media (max-width: 1200px) {
        .funnel-layout {
            grid-template-columns: 1fr 380px;
            gap: 24px;
        }

        .phone-frame {
            height: 580px;
        }
    }

    @media (max-width: 992px) {
        .funnel-container {
            padding: 16px 16px 60px;
        }

        .mobile-funnel-nav {
            display: flex;
        }

        .funnel-layout {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        .funnel-builder.mobile-hidden,
        .simulator-column.mobile-hidden {
            display: none !important;
        }

        .funnel-builder.mobile-visible,
        .simulator-column.mobile-visible {
            display: flex !important;
            width: 100%;
        }

        .simulator-column {
            position: static;
        }

        .phone-frame {
            max-width: 440px;
            margin: 0 auto;
            height: 600px;
        }
    }

    @media (max-width: 768px) {
        .funnel-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

        .header-actions {
            width: 100%;
            justify-content: space-between;
        }

        .btn-reset-simulator,
        .btn-save-funnel {
            flex: 1;
            justify-content: center;
        }

        .toggles-grid {
            grid-template-columns: 1fr;
        }

        .form-group-inline {
            flex-direction: column;
        }
    }

    @media (max-width: 600px) {
        .payment-methods-grid {
            grid-template-columns: 1fr;
        }

        .phone-frame {
            border-width: 6px;
            border-radius: 24px;
            height: 540px;
        }
    }
</style>
